// Removes a list of paths from the start of the path, if present
export const removeFromPath = (fromPath: string, pathsToRemove: string[]): string => {
  let result = fromPath;
  for (const path of pathsToRemove) {
    result = result.replaceAll(path, '');
  }

  return result;
}
